let getDiscountPercent = function (price, compareAtPrice, selector) {
  const discount = compareAtPrice - price;
  const discountPercentage = Math.floor(
    (discount / compareAtPrice) * 100
  );
  if (selector && discountPercentage > 0) {
    let discountElement = document.querySelector(selector);
    discountElement.innerHTML = `${discountPercentage}% OFF`;
    discountElement.classList.add('price-promo-percentage-off');
  } else {
    return discountPercentage;
  }
};

/**
 * adjusts the surround elements of the cta up or down based on whether the cta is being shown or hidden
 *
 * @param {string} direction - 'up' or 'down' - 'up' if moving surrounding elements up, 'down' if moving surrounding elements down
 */
let adjustSurroundingElements = function (
  direction = 'up',
  stickyCTAAdjacentElementIds,
  styleAdjustmentIntervalId
) {
  stickyCTAAdjacentElementIds.forEach(id => {
    const element = document.querySelector(`#${id}`);
    if (element) {
      element.style.transition = 'margin-bottom .3s';
    }
  });

  if (direction !== 'up' && direction !== 'down') {
    console.error(
      'adjustSurroundingElements function only takes one of two arguments: string "up" or string "down"'
    );
    return;
  }

  const directionStyles = {
    marginBottom: {
      up: '100px',
      down: null,
    },
  };

  if (styleAdjustmentIntervalId) {
    // if there's a previously running interval, clear it
    clearInterval(styleAdjustmentIntervalId);
  }

  styleAdjustmentIntervalId = setInterval(() => {
    // set a new interval for adjusting styles
    let allElementsExist = true;

    stickyCTAAdjacentElementIds.forEach(id => {
      const element = document.querySelector(`#${id}`);

      if (element) {
        // if the currently iterated element exists, adjust its style
        element.style.marginBottom =
          directionStyles.marginBottom[direction];
      } else {
        // else, set the flag to false to run the interval again
        allElementsExist = false;
      }
    });

    // once all elements' styles have been adjusted, clear the interval and stop looking for elements
    if (allElementsExist) {
      clearInterval(styleAdjustmentIntervalId);
      styleAdjustmentIntervalId = null; // reset the intervalId after clearing
    }
  }, 30);

  setTimeout(() => {
    // clear the interval after 5 seconds so it doesn't run forever
    clearInterval(styleAdjustmentIntervalId);
    styleAdjustmentIntervalId = null; // reset the intervalId after clearing
  }, 5000);
};

window.LG_custom = {
  getDiscountPercent: getDiscountPercent,
  adjustSurroundingElements: adjustSurroundingElements,
};
